import MuiToggleButton, { ToggleButtonProps } from '@mui/material/ToggleButton';
import MuiToggleButtonGroup, {
  ToggleButtonGroupProps,
} from '@mui/material/ToggleButtonGroup';
import { forwardRef } from 'react';

const ToggleButton = forwardRef<HTMLDivElement, ToggleButtonGroupProps>(
  ({ children, ...otherProps }, ref) => {
    return (
      <MuiToggleButtonGroup
        ref={ref}
        {...otherProps}
      >
        {children}
      </MuiToggleButtonGroup>
    );
  },
);

const Item = forwardRef<HTMLButtonElement, ToggleButtonProps>(
  ({ children, ...otherProps }, ref) => {
    return (
      <MuiToggleButton
        {...otherProps}
        ref={ref}
      >
        {children}
      </MuiToggleButton>
    );
  },
);

ToggleButton.displayName = 'ToggleGroup';

export default Object.assign(ToggleButton, { Item });
